import React from "react"
import PropTypes from "prop-types"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import "../css/site.scss"

export default class Template extends React.Component {
  static propTypes = {
    children: PropTypes.func,
  }

  render() {
    return (
      <div className="hero">
        <Helmet
          title="#710 inc."
          meta={[
            { name: "description", content: "#710 inc." },
            { name: "keywords", content: "#710 inc." },
          ]}
        />
        <div className="hero__content">
          {this.props.children()}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.js